import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ManagedRunPolicy from "./ManagedRunPolicy";

const ManagedRunPolicyModal = ({ open, onClose, projectId, projectName }) => {
  const handleOpenInNewTab = () => {
    window.open(`/project/managed_runs/${projectId}`, "_blank");
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="managed-run-policy-modal"
      aria-describedby="managed-run-policy-in-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "95%",
          maxWidth: 920,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AppBar
          position="static"
          elevation={0}
          sx={{
            bgcolor: "background.default",
            color: "text.primary",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Toolbar sx={{ minHeight: "48px !important", height: 48, px: 1.5 }}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ flexGrow: 1 }}>
              Managed run
            </Typography>
            <IconButton
              onClick={handleOpenInNewTab}
              aria-label="open in new tab"
              sx={{ color: "text.secondary" }}
            >
              <OpenInNewIcon />
            </IconButton>
            <IconButton
              edge="end"
              onClick={onClose}
              aria-label="close"
              sx={{ color: "text.secondary" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box
          sx={{ flexGrow: 1, overflow: "auto", bgcolor: "background.paper" }}
        >
          <ManagedRunPolicy
            params={{ id: projectId }}
            location={{ state: { project_name: projectName } }}
            navigate={() => {}}
            isModal={true}
            onClose={onClose}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ManagedRunPolicyModal;
